import { sentenceCase } from 'change-case';
import { filter } from 'lodash';
import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
// @mui
import {
  Alert,
  Button,
  Card,
  Checkbox,
  CircularProgress,
  Container,
  Grid,
  Paper,
  Popover,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableRow,
  Typography,
} from '@mui/material';
import Snackbar from '@mui/material/Snackbar';
// components
import Label from '../../components/label';

import Scrollbar from '../../components/scrollbar';
// sections
import { UserListHead } from '../../sections/@dashboard/user';

import { useNavigate, useParams } from 'react-router-dom';
import { DeleteClients, GetMyTasks, ReAssigTasks } from 'src/components/services/httpServices';
import TasksListToolbar from 'src/sections/@dashboard/Tasks/TasksListToolbar';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  // { id: 'id', label: 'Id', alignRight: false },
  { id: 'mstClientId', label: 'Client/Employer Name', alignRight: false },
  { id: 'activityName', label: 'Task Title', alignRight: false },
  { id: 'activityDate', label: 'Activity Date', alignRight: false },
  { id: 'comments', label: 'Details', alignRight: false },
  { id: 'status', label: 'Status', alignRight: false },
  { id: 'deadLine', label: 'Dead Line', alignRight: false },
  { id: 'assignedByName', label: 'Assigned by', alignRight: false },
];

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(
      array,
      (_user) =>
        _user?.activityName?.toLowerCase().indexOf(query.toLowerCase()) != -1 ||
        _user?.activityDate?.toLowerCase().indexOf(query.toLowerCase()) != -1 ||
        _user?.status?.toLowerCase().indexOf(query.toLowerCase()) != -1 ||
        _user?.comments?.toLowerCase().indexOf(query.toLowerCase()) != -1
    );
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function MyTasks() {
  let { id } = useParams();
  const [open, setOpen] = useState(null);

  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('desc');

  const [selected, setSelected] = useState([]);

  const [orderBy, setOrderBy] = useState('id');

  const [filterName, setFilterName] = useState('');

  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [TASKSLIST, setTasksList] = useState([]);
  const [message, setMessage] = useState('');
  const [saved, setSaved] = useState(false);
  const [vertical, setVertical] = useState('bottom');
  const [horizontal, setHorizontal] = useState('right');
  const [openMessage, setOpenMessage] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedAgent, setSelectedAgent] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetch = async () => {
      const response = await GetMyTasks();

      if (response !== null) {
        setLoading(false);
        setTasksList(response);
        console.log('response', response);
      }
    };
    fetch();
  }, []);
  const rowClicked = async (row) => {
    console.log('row', row);
    setSelectedRow(row);
  };
  const deleteTasksLIST = async (selectedUsersList) => {
    const payload = {
      ids: selected,
    };

    //  console.log(payload);
    let response = await DeleteClients(payload);
    // console.log('PostResponse:', response);

    if (response.status == 200) {
      const isSelected = (user) => {
        let check = selected.includes(user.id);
        return !check;
      };
      const list = TASKSLIST.filter((e) => {
        if (isSelected(e)) {
          return e;
        }
      });
      setTasksList(list);
      setSelected([]);
      setMessage(response.data);
      setSaved(true);
      setOpenMessage(true);
    } else {
      setMessage(response.data);
      setSaved(false);
      setOpenMessage(true);
    }
  };
  const handelAssignment = async () => {
    const payload = {
      ids: selected,
    };
    console.log('SS', payload);
    if (selectedAgent == null) {
      setMessage('Please Select Agent.');
      setSaved(false);
      setOpenMessage(true);
    } else if (selected.length <= 0) {
      setMessage('Please Select Tasks.');
      setSaved(false);
      setOpenMessage(true);
    } else {
      let response = await ReAssigTasks(selectedAgent.id, payload);

      if (response.status == 200) {
        setSelected([]);
        setMessage(response.data);
        setSaved(true);
        setOpenMessage(true);
        setTimeout(() => {
          window.location.reload(false);
        }, 2000);
      } else {
        setMessage(response.data);
        setSaved(false);
        setOpenMessage(true);
      }
    }
  };

  const handleDetails = (row) => {
    //  console.log('row:', selectedRow);
    row?.mstClientId != null
      ? navigate(`/app/ClientDetails/${row.id}/${row.mstClientId}/${true}`)
      : navigate(`/app/CompanyDetails/${row.id}/${row.mstCompanyId}/${false}`);
  };

  const handleCloseMenu = () => {
    setOpen(null);
  };
  const handleClose = () => {
    setOpenMessage(false);
  };
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = TASKSLIST.map((n) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, id, status) => {
    if (status == 'Done') {
      setMessage('You can not Select Already Done Tasks!');
      setSaved(false);
      setOpenMessage(true);
    } else {
      const selectedIndex = selected.indexOf(id);
      let newSelected = [];
      if (selectedIndex === -1) {
        newSelected = newSelected.concat(selected, id);
      } else if (selectedIndex === 0) {
        newSelected = newSelected.concat(selected.slice(1));
      } else if (selectedIndex === selected.length - 1) {
        newSelected = newSelected.concat(selected.slice(0, -1));
      } else if (selectedIndex > 0) {
        newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
      }
      setSelected(newSelected);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleFilterByName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - TASKSLIST.length) : 0;

  const filteredUsers = applySortFilter(TASKSLIST, getComparator(order, orderBy), filterName);

  const isNotFound = !filteredUsers.length && !!filterName;

  return (
    <>
      <Helmet>
        <title> Tasks | Immigration System </title>
      </Helmet>

      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5} marginTop={4}>
          <Typography variant="h4" gutterBottom>
            My Tasks
          </Typography>

          <Button variant="contained" onClick={handelAssignment}>
            Forward-Task
          </Button>
        </Stack>
        {loading ? (
          <Grid display="flex" alignItems="center" justifyContent="center" height="40vh" container>
            <CircularProgress size={60} thickness={3} value={100} />
          </Grid>
        ) : (
          <Card>
            <TasksListToolbar
              // numSelected={selected.length}
              numSelected={selected.length}
              selectedUsers={selected}
              setSelected={setSelected}
              filterName={filterName}
              onFilterName={handleFilterByName}
              // deleteUsers={deleteTasksLIST}
              alluser={true}
              setSelectedAgent={setSelectedAgent}
            />

            <Scrollbar>
              <TableContainer sx={{ minWidth: 800 }}>
                <Table>
                  <UserListHead
                    order={order}
                    orderBy={orderBy}
                    headLabel={TABLE_HEAD}
                    rowCount={TASKSLIST.length}
                    numSelected={selected.length}
                    onRequestSort={handleRequestSort}
                    onSelectAllClick={handleSelectAllClick}
                  />
                  <TableBody>
                    {filteredUsers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                      const {
                        id,
                        activityName,
                        activityDate,
                        comments,
                        status,
                        deadLine,
                        mstClient,
                        mstCompany,
                        assignedToUser,
                        assignedByName,
                      } = row;
                      const selectedCompany = selected.indexOf(id) !== -1;

                      return (
                        <TableRow
                          hover
                          key={id}
                          tabIndex={-1}
                          role="checkbox"
                          selected={selectedCompany}
                          onClick={() => rowClicked(row)}
                        >
                          <TableCell padding="checkbox">
                            <Checkbox checked={selectedCompany} onChange={(event) => handleClick(event, id, status)} />
                          </TableCell>

                          <TableCell onClick={() => handleDetails(row)} component="th" scope="row" padding="none">
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Typography variant="subtitle2" noWrap>
                                {mstClient != null ? mstClient.fullName : mstCompany.companyName}
                              </Typography>
                            </Stack>
                          </TableCell>
                          <TableCell onClick={() => handleDetails(row)} component="th" scope="row" padding="none">
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Typography variant="subtitle2" noWrap={false}>
                                {activityName}
                              </Typography>
                            </Stack>
                          </TableCell>
                          <TableCell onClick={() => handleDetails(row)} component="th" scope="row" padding="none">
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Typography variant="subtitle2" noWrap={false}>
                                {activityDate?.split('T')[0]}
                              </Typography>
                            </Stack>
                          </TableCell>

                          <TableCell onClick={() => handleDetails(row)} component="th" scope="row" padding="none">
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Typography variant="subtitle2" noWrap={false}>
                                {comments}
                              </Typography>
                            </Stack>
                          </TableCell>
                          <TableCell onClick={() => handleDetails(row)} component="th" scope="row" padding="none">
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Label color={status == 'Pending' ? 'warning' : 'success'}>
                                {status == 'Pending' ? sentenceCase('Pending') : sentenceCase('Done')}
                              </Label>
                            </Stack>
                          </TableCell>
                          <TableCell onClick={() => handleDetails(row)} component="th" scope="row" padding="none">
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Typography variant="subtitle2" noWrap>
                                {deadLine?.split('T')[0]}
                              </Typography>
                            </Stack>
                          </TableCell>
                          <TableCell onClick={() => handleDetails(row)} component="th" scope="row" padding="none">
                            <Stack direction="row" alignItems="center" spacing={2}>
                              <Typography variant="subtitle2" noWrap={false}>
                                {assignedByName}
                              </Typography>
                            </Stack>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                    {emptyRows > 0 && (
                      <TableRow style={{ height: 53 * emptyRows }}>
                        <TableCell colSpan={6} />
                      </TableRow>
                    )}
                  </TableBody>

                  {isNotFound && (
                    <TableBody>
                      <TableRow>
                        <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                          <Paper
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            <Typography variant="h6" paragraph>
                              Not found
                            </Typography>

                            <Typography variant="body2">
                              No results found for &nbsp;
                              <strong>&quot;{filterName}&quot;</strong>.
                              <br /> Try checking for typos or using complete words.
                            </Typography>
                          </Paper>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Scrollbar>

            <TablePagination
              rowsPerPageOptions={[25, 50, 100, 500]}
              component="div"
              count={TASKSLIST.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Card>
        )}
        {saved ? (
          <Snackbar
            anchorOrigin={{ vertical, horizontal }}
            key={vertical + horizontal}
            open={openMessage}
            autoHideDuration={4000}
            onClose={handleClose}
          >
            <Alert elevation={6} variant="filled" onClose={handleClose} severity="success">
              {message}
            </Alert>
          </Snackbar>
        ) : (
          <Snackbar
            key={vertical + horizontal}
            anchorOrigin={{ vertical, horizontal }}
            open={openMessage}
            autoHideDuration={4000}
            onClose={handleClose}
          >
            <Alert elevation={6} variant="filled" onClose={handleClose} severity="error">
              {message}
            </Alert>
          </Snackbar>
        )}
      </Container>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      ></Popover>
    </>
  );
}
